import { Component, OnInit, Input } from '@angular/core';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { error } from 'protractor';
import { PermitService } from 'app/services/permit.service';
import { AuthWebService } from 'app/services/authweb.service';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import { TransportAssocService } from 'app/services/transport-assoc.service';
import { DatePipe } from '@angular/common';
import { PermitTypeService } from 'app/services/permit-type.service';
import { PopupService } from 'app/services/shared/popup.service';
import { CompliancereturnsService } from 'app/services/compliancereturns.service';
import { ApplicationService } from 'app/services/application.service';
import { FormControl, Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';

import { Router,  ActivatedRoute, Params  } from '@angular/router';
import { isDate } from 'angular';
import { from } from 'rxjs';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';

declare var printJS: any;


declare var $;

@Component({
  selector: 'printing',
  templateUrl: './printing.component.html',
  styleUrls: ['./printing.component.css']
})

export class PrintingComponent implements OnInit {

  @Input('ctrlData') ctrlData: any;
  count: number = 0;
  isLoading: Boolean = false;
  message: string = 'Loading  permits, please wait...';
  currentPage = 1;
  isEmpty: boolean = false;
  permits: any = [];
  page = 1;
  pageSize: number = 10;
  FaceValueNumber: string = "";
  criteria = "DateValidFrom";
  numberofdays = 0;
  user = '';
  dateValidFrom = null;
  isPrinted = false;
  FaceExists = false;
  description: any = "";
  maxnumberofdays: number;
  pritIndex: any = "";
  PermitStatus8: number;
  PermitStatus2: number;
  PermitStatus4: number;
  PermitStatus6: number;
  NumberOfPassengers: number;
  userRoles: any;
  pdfSrc:any;
  enabledNumber:boolean=false;
  isReprint:boolean = false;
  permTypeCode:any;
  currentDate:Date= new Date();
  //contractNumberOfDays: number;
  enableChangeNumberOfPassengers: boolean = false;
  complianceCertficateList : any = [];
  applicationId : any;
  form: UntypedFormGroup;
  isJustApproved : Boolean = false;
  oldStartDate : Date;
  oldEndDate :Date;
  isPermitPrintInProgress: boolean = false;

  constructor(private formBuilder: UntypedFormBuilder, public utility: UtilityServiceService,
     private complianceService:CompliancereturnsService,private transService: TransportAssocService,
      private printService: PermitService, private permitType: PermitTypeService, private authWebService: AuthWebService,
       private notify: ToastrService, private datepipe: DatePipe, private msgService: PopupService,
       public applicationService: ApplicationService, private router : Router, private activeRoute: ActivatedRoute,
       private confirmDialogService: ConfirmDialogService) { }



  ngOnInit() {
    this.isLoading = true;
    if(this.ctrlData == null || this.ctrlData == undefined)
    {
      this.ctrlData = null;

        this.activeRoute.params.subscribe((params: Params) => {
          let appId = params['pId'];
          let isapproved = JSON.parse(params['isapproved']);
          this.isJustApproved = isapproved;
          if(isapproved)
          {
             this.applicationService.getApplicationByAppId(appId).subscribe(x=>
            {
              this.ctrlData = {data:x};
              this.initPage();
              this.isLoading = false;
            });
          }
        });
    }
    else
    {
      this.initPage();
      this.isLoading = false;
    }
  }

  setApplicationLock(application,lockStatus)
  {
    application.isLocked = lockStatus;
    application.isLockedBy = lockStatus? this.authWebService.userData.User.UserName : "";

    this.applicationService.putApplication(application).subscribe((r)=>
    {
      if(lockStatus)
      {
        this.notify.info("Application Locked By '" + application.isLockedBy + "'", "Lock Application", { timeOut: 1000 });
      }
      else
      {
        this.notify.info("Application Unlocked", "UnLock Application", { timeOut: 1000 });
      }
    }, error=>{

    });
  }

  initPage()
  {
    if(this.ctrlData.data != null && this.ctrlData.data != undefined)
    {
      this.ctrlData.application = this.ctrlData.data;
    }
    if(this.ctrlData.data.isLocked == false)
    {
      this.setApplicationLock(this.ctrlData.data, true);
    }

    this.applicationId = this.ctrlData.data.id;
    this.initForm();
    this.utility.page=1;
    this.currentDate= new Date();

    this.count = this.ctrlData.data.Permits.length;

    this.initializeValidFromDate();
    this.isEmpty = (this.count == 0) ? true : false;
    this.user = this.authWebService.userInfo().username;
    this.userRoles = this.authWebService.userData.Roles;

    this.PermitStatus2 = + this.authWebService.userData.Configurations.find(config => config.Code == "PermitStatus2").Value;  // submitted
    this.PermitStatus4 = + this.authWebService.userData.Configurations.find(config => config.Code == "PermitStatus4").Value;  // approved
    this.PermitStatus6 = + this.authWebService.userData.Configurations.find(config => config.Code == "PermitStatus6").Value;  // application and permit fee quote has been accepted
    this.PermitStatus8 = + this.authWebService.userData.Configurations.find(config => config.Code == "PermitStatus8").Value;  // permit has been printed

    this.permTypeCode = this.ctrlData.data.permit_type.code;
    this.initPermitTypeDays();
    this.initPermitMaxDate();

    if(this.ctrlData.data.permit_type.permit_years == 5){
      this.getComplianceCertificates();
    }
  }

  initForm() {
    this.form = this.formBuilder.group({
      route_detail: ['', [<any>Validators.required]],
      route_summary: ['', [<any>Validators.required]]
    });
  }

  formChanges(){
    this.form.statusChanges.subscribe(
      result => {
        //this.ctrlData.formValid = result == 'VALID'? true : false
      });
  }

  initPermitMaxDate()
  {
    let isValidPermitType: boolean = (
      this.permTypeCode.includes("TOG-F-14") ||
      this.permTypeCode.includes("TOG-FTD-14") ||
      this.permTypeCode.includes("TOG-C-14") ||
      this.permTypeCode.includes("TOG-SE-14") ||
      this.permTypeCode.includes("TOG-TOE-14") ||
      this.permTypeCode.includes("TOG-O-14D") ||
      this.permTypeCode.includes("syxqyp") ||
      this.permTypeCode.includes("nlg3ty")
    );

    for (let i = 0; i < this.count; i++) {

      let tempToDate : Date = new Date(this.ctrlData.data.Permits[i].DateValidFrom);
      //console.log("this.ctrlData.data.Permits[i].MaxDate : " + JSON.stringify(this.ctrlData.data.Permits[i].MaxDate));
      if(isValidPermitType)
      {
        this.ctrlData.data.Permits[i].MaxDate =  this.addDays (tempToDate, 14);
       // console.log("this.ctrlData.data.Permits[i].MaxDate : " + JSON.stringify(this.ctrlData.data.Permits[i].MaxDate));
      }
    }
  }

  initPermitTypeDays()
  {
      let isValidPermitType: boolean = (
        this.permTypeCode.includes("TOG-F-14") ||
        this.permTypeCode.includes("TOG-FTD-14") ||
        this.permTypeCode.includes("TOG-C-14") ||
        this.permTypeCode.includes("TOG-SE-14") ||
        this.permTypeCode.includes("TOG-TOE-14") ||
        this.permTypeCode.includes("TOG-O-14D") ||
        this.permTypeCode.includes("7mspyr") ||
        this.permTypeCode.includes("f9kudq") ||
        this.permTypeCode.includes("syxqyp") ||
        this.permTypeCode.includes("nlg3ty") ||
        this.permTypeCode.includes("1n9udp")
      );
      if(isValidPermitType)
      {
       // this.contractNumberOfDays = 14;
        this.enableChangeNumberOfPassengers = false;
      }
      else{
       // this.contractNumberOfDays = 365 * 5;
        this.enableChangeNumberOfPassengers = true;
      }
  }


  isPrintable = (fv: any) => {
    if (fv == null) return false;
    return fv.length > 0;
  }



  changeView = (activeC: number) => {
    if(this.isJustApproved)
    {
      this.router.navigateByUrl('/permit/approval');
    }
    else{
    this.ctrlData.currentActive = activeC;
    }
  }

  updateRouteForApproval()
  {
      this.isLoading = true;
      this.applicationService.getById(this.applicationId).subscribe((application:any)=>{
      application.route_detail = this.form.value.route_detail;

      this.applicationService.putApplication(application)
      .subscribe(result => {
        this.isLoading = false;
       // this.saveDepatureDestination();
        this.notify.success('Update Route Details','Route details updated successfully');

        },
        error => {
          this.isLoading = false;

          this.notify.error('Failed to update route details. If the problem persist, please contact system administrator.','Save Application')

        // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
        return;
        });
      });
  }


  onNextOrPrevious = (page) => {
    return page;
  }

  getComplianceCertificates(){
    this.complianceCertficateList = [];
    this.ctrlData.data.Permits.forEach(permit => {
      this.complianceService.GetComplianceCertificatesById(permit.ID).subscribe((certs:any) =>{
       certs.forEach(cert => {
        this.complianceCertficateList.push(cert);
       });
      });
    });

  }

  permitPrintCompliance(obj)
  {
    this.isLoading = true;
    this.tryPrintingPermitCompliance(obj);
  }

  permitPrint(obj){
    if(this.validateNumberOfDays(obj))
    {
        if((this.PermitStatus4 != obj.status_id) && (obj.status_id != this.PermitStatus8))
        {
          this.notify.warning(`Cannot print Non-Approved Permit`, 'Permit Printing');
        }
        else
        if(this.PermitStatus8==obj.status_id && !obj.enabledNumber){
          // this.msgService.showYesNo('Permit print', `This Permit is already Printed,do you want to reprint permit?`, '').subscribe(isConfirmed => {
          //   if(isConfirmed){

          //     this.enabledNumber=true;
          //     obj.enabledNumber=true;
          //     this.isReprint = true;
          //     //this.reprintPermit(obj.ID);
          //   }else{
          //     obj.enabledNumber=false;
          //     return;
          //   }
          // });
          this.confirmDialogService.confirmThis("This Permit is already Printed,do you want to reprint permit?", () => {

            this.enabledNumber=true;
            obj.enabledNumber=true;
            this.isReprint = true;
            //this.reprintPermit(obj.ID);

          }, () =>  {
            obj.enabledNumber=false;
              return;
          })
        }else{
          this.updateCarrier(obj);
        }

      }
  }


  updateCarrier(obj) {
    if (!this.isPrintable(obj.FaceValueNumber)) {
      this.notify.warning(`A face value number for permit number ${obj.PermitNumber} is missing.`, 'Permit Printing');
      return;
    }

    if(!this.isReprint)
    {
        this.UpdateDate(obj);
    }

    this.isLoading = true;
    let carrierObj: any = Object();
    carrierObj['id'] = obj.ID;
    carrierObj['carrier_code'] = this.ctrlData.data.carrier.carrier_code;
    carrierObj['registration_number'] = this.ctrlData.data.carrier.registration_number;
    carrierObj['tax_number'] = this.ctrlData.data.carrier.tax_number;
    carrierObj['carrier_name'] = this.ctrlData.data.Name;
    carrierObj['trading_name'] = this.ctrlData.data.carrier.trading_name;
    carrierObj['physical_address_1'] = this.ctrlData.data.carrier.physical_address_1;
    carrierObj['physical_address_2'] = this.ctrlData.data.carrier.physical_address_2;
    carrierObj['physical_address_3'] = this.ctrlData.data.carrier.physical_address_3;
    carrierObj['physical_address_town'] = this.ctrlData.data.carrier.physical_address_town;
    carrierObj['physical_post_code'] = this.ctrlData.data.carrier.physical_post_code;
    // this.tryPrinting(obj);

    // this.printService.UpdatePreviousPermitsIssued(obj.PermitNumber).subscribe(res => {


    // });

    this.getAsscoName(this.ctrlData.data.carrier.transport_assoc_id, carrierObj, obj);

  }
  getAsscoName(transportAssocId, carrierObj, obj) {

    if (transportAssocId == null) {
      this.printService.updateCarrier(carrierObj).subscribe(res => {

        this.tryPrinting(obj);
      });
    }
    else {
      this.transService.getTransporAssocById(transportAssocId).subscribe((res:any) => {
        //console.log(res);
        if (res != null) {
          carrierObj['assoc_name'] = res.description;
        } else {
          carrierObj['assoc_name'] = "";
        }
        this.printService.updateCarrier(carrierObj).subscribe(res => {
          this.tryPrinting(obj);
        });
      }, error => {
        this.printService.updateCarrier(carrierObj).subscribe(res => {
          this.tryPrinting(obj);
        });
      }
      )
    }
  }
  tryPrintingPermitCompliance(obj: any)
  {
    this.isLoading = true;
    let permitTemplate : string = "Compliance";
    this.message = 'Processing your request, please wait...';

    var printobj = {
      Reportname : permitTemplate,
      validFrom :obj.ComplianceEndDate,
         pId :obj.ComplianceDetailId,
        face_value :obj.FaceValueNumber,
        username :this.user,
        NumDays:0,
        isCompliancePrint:true
    };


    this.printService.PrintingPermit(printobj).subscribe(x =>{

    const url= window.URL.createObjectURL(x);
      this.isPermitPrintInProgress = true;
      printJS({ printable: url, type: 'pdf', showModal: true, modalMessage: 'Processing your request, please wait...' });
      this.isLoading = false;
      this.isPermitPrintInProgress = false;
      this.ngOnInit();
    },error => {
      console.log(error);
    });
  }
  tryPrinting = (obj: any) => {
    let permitTemplate : string = this.ctrlData.data.permit_type.PermitTemplate;
    this.isLoading = true;
    this.message = 'Processing your request, please wait...';
    var printobj = {
      Reportname : permitTemplate,
      validFrom :obj.DateValidFrom,
      pId :obj.ID,
      face_value :obj.FaceValueNumber,
      username :this.user,
      NumDays:obj.NumberOfDays,
      RegNumber:obj.RegNumber,
      isReprint : this.isReprint

    };
    var printAnnexureobj = {
      Reportname : 'Annexure',
      validFrom :obj.DateValidFrom,
         pId :obj.ID,
        face_value :obj.FaceValueNumber,
        username :this.user,
      NumDays:obj.NumberOfDays

    };
    //console.log(printobj);
    this.printService.isPrinted(obj.ID).subscribe((rsc:any) => {
      this.isPrinted = false;
     this.isPrinted = rsc.IsPrinted;
      if (!this.isPrinted || (this.isPrinted && this.isReprint)) {

        this.printService.getFaceValueNumber(obj.FaceValueNumber).subscribe((result:any) => {
         // this.isLoading = false;
          this.FaceValueNumber = result.HasValue;


          //console.log(JSON.stringify(obj) +  " :test");

          if (!this.FaceValueNumber) {

          this.enabledNumber=false;
          obj.enabledNumber=false;

         // console.log('obj.TemLongID : ' + obj.TemLongID);
          //console.log('!obj.Saved : ' + !obj.Saved);
          //console.log('obj.NumberOfDays : ' + obj.NumberOfDays);
         // console.log('this.ctrlData.data.permit_type.permit_days : ' + this.ctrlData.data.permit_type.permit_days);
         // console.log('(obj.TemLongID == 1 && !obj.Saved && (obj.NumberOfDays != this.ctrlData.data.permit_type.permit_days)) : ' +
          ///        (obj.TemLongID == 1 && !obj.Saved && (obj.NumberOfDays != this.ctrlData.data.permit_type.permit_days)));

            if (obj.TemLongID == 1 && !obj.Saved && (obj.NumberOfDays != this.ctrlData.data.permit_type.permit_days)) {

              //this.isLoading = false;
              // this.notify.warning("The permit days have changed, please save the permit","Permit Printing");
              // this.msgService.showYesNo('Permit Print', `You have changed the permit days but haven't saved them yet`, 'Do you want to print the permit with the old Valid To dates')
              // .subscribe(isConfirmed => {
              //   if (isConfirmed) {


              //     this.printService.PrintingPermit(printobj).subscribe(x =>{
              //       const url= window.URL.createObjectURL(x);
              //       //console.log(x);
              //       printJS({ printable:url, type: 'pdf', showModal: true, modalMessage: 'Processing your request, please wait...' });

              //       obj.status_id = 75;
              //       // this.printService.PrintingAnneuxre(printAnnexureobj).subscribe(x=>{
              //       //   //console.log(x);
              //       //   const url= window.URL.createObjectURL(x);
              //       //   //console.log(url);

              //       //   this.msgService.showYesNo('Permit Print', `You are about to open Permit Annexure`, 'Do you want to open the Annexure?').subscribe(isConfirmed =>
              //       //     {
              //       //     if (isConfirmed) {

              //       //       window.open(url, '_blank'); // <- This is what makes it open in a new window.
              //       //       // this.printService.DownloadPDF("Annexure", obj.ID, obj.FaceValueNumber, this.user, obj.DateValidFrom);
              //       //     }
              //       //   })

              //       // })
              //     },error => {
              //       //console.log(error);
              //     })

              //     // this.printService.DownloadPDF("Annexure", obj.ID, obj.FaceValueNumber, this.user, obj.DateValidFrom);

              //   }

              // })
              this.confirmDialogService.confirmThis("You have changed the permit days but haven't saved them yet. Do you want to print the permit with the old Valid To dates", () => {
                this.isPermitPrintInProgress = true;
                this.printService.PrintingPermit(printobj).subscribe(x =>{
                  const url= window.URL.createObjectURL(x);
                  console.log("Print Url", url);
                  window.open(url, '_blank');
                  printJS({ printable: url, type: 'pdf', showModal: true, modalMessage: 'Processing your request, please wait...' });
                  this.isPermitPrintInProgress = false;
                  obj.status_id = 75;
                  // this.printService.PrintingAnneuxre(printAnnexureobj).subscribe(x=>{
                  //   //console.log(x);
                  //   const url= window.URL.createObjectURL(x);
                  //   //console.log(url);

                  //   this.msgService.showYesNo('Permit Print', `You are about to open Permit Annexure`, 'Do you want to open the Annexure?').subscribe(isConfirmed =>
                  //     {
                  //     if (isConfirmed) {

                  //       window.open(url, '_blank'); // <- This is what makes it open in a new window.
                  //       // this.printService.DownloadPDF("Annexure", obj.ID, obj.FaceValueNumber, this.user, obj.DateValidFrom);
                  //     }
                  //   })

                  // })
                },error => {
                  //console.log(error);
                })

              }, () =>  {
                //No here
              })


            }

            else if (obj.TemLongID == 1 && obj.Saved && (obj.NumberOfDays != this.ctrlData.data.permit_type.permit_days)) {
              this.isPermitPrintInProgress = true;
              this.printService.PrintingPermit(printobj).subscribe((x: Blob) => {
                const url = window.URL.createObjectURL(x);
                printJS({ printable: url, type: 'pdf', showModal: true, modalMessage: 'Processing your request, please wait...' });
                this.isPermitPrintInProgress = false;
                obj.status_id = 75;
              }, error => {
                console.log(error);
              })


              // this.printService.DownloadPDF("Annexure", obj.ID, obj.FaceValueNumber, this.user, obj.DateValidFrom);
              this.ngOnInit();
            } else {

              try {
                this.isPermitPrintInProgress = true;
                this.printService.PrintingPermit(printobj).subscribe(x =>{

                  //console.log(x);
                  const url= window.URL.createObjectURL(x);
                  console.log("Print Url", url);
                  printJS({ printable: url, type: 'pdf', showModal: true, modalMessage: 'Processing your request, please wait...' });
                  this.isPermitPrintInProgress = false;
                  obj.status_id = 75;
                  this.ngOnInit();
                  //this.CreateComplianceRecord();
                  // this.printService.PrintingAnneuxre(printAnnexureobj).subscribe(x=>{
                  //   const url= window.URL.createObjectURL(x);
                  //   this.msgService.showYesNo('Permit Print', `You are about to open Permit Annexure`, 'Do you want to open the Annexure?').subscribe(isConfirmed =>
                  //     {
                  //     if (isConfirmed) {

                  //       window.open(url, '_blank'); // <- This is what makes it open in a new window.



                  //       // this.printService.DownloadPDF("Annexure", obj.ID, obj.FaceValueNumber, this.user, obj.DateValidFrom);



                  //     }

                  //   })

                  // })
                 },error => {
                  //console.log(error);
                })



                // this.printService.DownloadPDF("Annexure", obj.ID, obj.FaceValueNumber, this.user, obj.DateValidFrom);

              } catch (e) {

              }

            }


          }
          else {
            this.isLoading = false;
            this.notify.warning("The face value number already exists, please choose another one.", "Permit Printing");
            this.enabledNumber=true;
            obj.enabledNumber=true;
          }


        });

      } else {
          this.isLoading = false;
          this.notify.warning("This permit has already been printed.", "Permit Printing");
      }


      this.isLoading = false;
    }, error => {
      this.isLoading = false;
    })

  }

  initializeValidFromDate() {
    let g = new Date();
    let mm = (g.getMonth() + 1).toString();
    if (mm.length == 1) {
      mm = "0" + mm;
    }
    let dd = (g.getDate()).toString();
    if (dd.length == 1)
      dd = "0" + dd;
    this.dateValidFrom = g.getFullYear() + "-" + mm + "-" + dd;

    for (let i = 0; i < this.count; i++) {

      let permitTypeToUse = this.getPermtypeToUse( this.ctrlData.data.Permits[i]);
      this.ctrlData.data.Permits[i].TemLongID = this.ctrlData.data.permit_type.temp_long_ind;
      //this.ctrlData.data.Permits[i].NumberOfDays = this.ctrlData.data.permit_type.permit_days;

      this.ctrlData.data.Permits[i].IsPermit = this.ctrlData.data.permit_type.is_permit
      // this.ctrlData.data.Permits[i].MinDays = this.ctrlData.data.permit_type.permit_days;
      this.ctrlData.data.Permits[i].maxnumberofdays = this.ctrlData.data.permit_type.permit_days;
      this.ctrlData.data.Permits[i].Saved = false;


      let tempFromDate : Date = this.oldStartDate = new Date(this.ctrlData.data.Permits[i].DateValidFrom);
      let tempToDate : Date = this.oldEndDate = new Date(this.ctrlData.data.Permits[i].DateValidTo);
      this.ctrlData.data.Permits[i].NumberOfDays = this.getDifferenceInDays(tempFromDate, tempToDate);
      this.ctrlData.data.Permits[i].ValidNumberOfDays = this.getValidNumberOfDays(permitTypeToUse, this.ctrlData.data.Permits[i]);
     // console.log("tempToDate=  :" + tempToDate );


      // this.ctrlData.data.Permits[i].DateValidTo =  new Date(_dateValidTo);
      // this.ctrlData.data.Permits[i].DateValidFrom = new Date(_dteValidFrom);

      //this.ctrlData.data.Permits[i].FaceValueNumber = "";
      //let rd = this.ctrlData.data.Permits[i].DateValidFrom;

     // if (!this.isRenewal(this.ctrlData.data.Permits[i].Renewal_num))
      //  {
    //      this.ctrlData.data.Permits[i].DateValidFrom = this.datepipe.transform(rd,'dd/MM/y');
    //    }
   //   else
    //  {
    //    this.ctrlData.data.Permits[i].DateValidFrom =this.datepipe.transform(rd,'dd/MM/y');
    //  }
    }
  }

  getValidNumberOfDays(permType, permit) : number
  {
    switch(this.ctrlData.data.permit_type.id)
    {
      case 15: //Amendment of Permit
      case 16: //Replacement of Vehicle
      case 17: //Correction of Permit
      case 32: //Duplicate Permits
          return this.getDifferenceInDays(new Date(this.oldStartDate), new Date(this.oldEndDate));
        break;
        default:
          if(permType.permit_days != 0)
            {
              return permType.permit_days;
            }
            else if(permType.permit_months != 0)
            {
            return Math.round(permType.permit_months * 30.4375);
            }
            else if(permType.permit_years != 0)
            {
            return Math.round(permType.permit_years * 365.25);

            }

          break
    }


  }
  valuechange(item) {
    //console.log("Item: " + item);
    let d = new Date(item['DateValidFrom']);
    let to = item['DateValidTo'];

    item['DateValidTo'] = new Date(d.getTime() + (1000 * 60 * 60 * 24 * item['NumberOfDays']));
   // console.log(" valuechange(item) ==== Valid Date :" + item['DateValidTo']);

  }

  getDateFrom(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();



    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;



    return [year, month, day].join('-');
  }

   //================================================================== UpdateDate

  UpdateDate(obj) {

    //console.log("passed Obj  : " + JSON.stringify(obj) );

   // gDateTo


        this.isLoading = true;
        let dateto = this.datepipe.transform(obj.DateValidTo, 'yyyy-MM-dd')
        let datefrom = this.datepipe.transform(obj.DateValidFrom, 'yyyy-MM-dd')
        let passenger_number: number = 0;
        if(obj.NumberOfPassengers == null || obj.NumberOfPassengers == "")
        {
          passenger_number = 0;
        }
        else{
          passenger_number = obj.NumberOfPassengers;
        }

        let dateDiff = this.getDifferenceInDays( new Date(obj.DateValidFrom), new Date(obj.DateValidTo) );
        //console.clear();
        obj.NumberOfDays = dateDiff;

        if(this.validateNumberOfDays(obj))
        {
          this.printService.SaveValidDate(obj.ID, dateto ,datefrom, passenger_number).subscribe(res => {
            this.isLoading = false;
            //console.log("Valid Date : " +datefrom + " " + datefrom);
            obj.Saved = true;
            this.notify.success(`Permit dates updated successfully.`);
          }, error => {
            this.isLoading = false;
            this.notify.error(`An error occured`);
          });
        }


/*
        gDateTo: Date;
        gDateFrom: Date;

        let temptDateFrom: Date = new Date(datefrom);
        temptDateFrom.setHours(0, 0, 0, 0);
        let currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        console.log("currentDate : " + JSON.stringify(currentDate)  + " datefrom : " +  JSON.stringify(temptDateFrom) );

        if(temptDateFrom < currentDate)
        {
          this.isLoading = false;
          this.notify.error("Starting date cannot have date in the past", "Date Error", { timeOut: 3000 });
          return;
        }

        let temptDateTo: Date = new Date(dateto);
        temptDateTo.setHours(0, 0, 0, 0);

        console.log("currentDate : " + JSON.stringify(currentDate)  + " temptDateTo : " +  JSON.stringify(temptDateTo) );
        if(temptDateTo < currentDate)
        {
          this.isLoading = false;
          this.notify.error("End date cannot have date in the past", "Date Error", { timeOut: 3000 });
          return;
        }
 */
  }
  //==================================================================

  isRenewal = (indicator) => {
    return (indicator > 0);
  }
  openModal(item, index) {
    this.description = item.condition_print;
    this.pritIndex = index;
    document.getElementById('specialCondition').click()
    // $("#Manager").modal('show');
  }
  onClose() {
    document.getElementById('closeSpecialCondition').click()

    // $("#Manager").modal('hide');
  }
  savePrintCondition() {
    this.ctrlData.data.Permits[this.pritIndex].condition_print = this.description;
    let payload: any = this.ctrlData.data.Permits[this.pritIndex];
    this.printService.updatePrintCondtions(payload).subscribe(res => {
      //console.log(res);
      this.notify.success("Special conditions added", "Permit Printing");
      this.onClose();
    }, error => {
      //console.log(error);
    })
  }
  changes() {
    this.ctrlData.data.Permits[this.pritIndex].condition_print = this.description;

  }

  isPrintingDone = (item) => {
    // do compliance save

        if(!item.enabledNumber){
      return (this.PermitStatus8 == item.status_id);
    }
    else{
      return false;
    }
  }

  isCertificatePrintingDone = (item) => {
    return item.ComplianceStatusId == 4; //printed
  }

  reprintPermit(id){
    let permitTemplate : string = this.ctrlData.data.permit_type.PermitTemplate;
    let obj ={
      pId: id,
      ReportName: permitTemplate

    }
    //console.log(obj);

    this.isLoading = true;
    this.isPermitPrintInProgress = false;
    this.printService.PrintingPermitView(obj).subscribe(data => {
      let objectURL = URL.createObjectURL(data);
      printJS({ printable: objectURL, type: 'pdf', showModal: true, modalMessage: 'Processing your request, please wait...' });
      this.isLoading = false;
      this.isPermitPrintInProgress = false;
      this.isLoading = false;

    })
  }

  viewPrintedPermit(id){
    let permitTemplate : string = this.ctrlData.data.permit_type.PermitTemplate;
    let obj ={
      pId: id,
      ReportName: permitTemplate

    }
    //console.log(obj);

    this.isLoading = true;
    this.printService.PrintingPermitView(obj).subscribe(data => {
      let objectURL = URL.createObjectURL(data);
      this.pdfSrc = objectURL;
      document.getElementById('btnShowPrintView').click()
      this.isLoading = false;

    })
  }

  isReprintUser(permitItem){

    let statusId = permitItem.status_id;
    let reprintUserRole = this.userRoles.find(x => x.Code == 'MNGMT');

    if (permitItem.VehicleType == null || permitItem.RegNumber == null)
    {
      return true
    }
    else
    {
      if (statusId == this.PermitStatus8 && reprintUserRole == undefined)
      {
        return true
      }
      else
      {
        return false
      }
    }
  }
  //==================================================================

  onDateSelect(event, item, itemSelectId)
  {
    let dateto = this.datepipe.transform(event, 'dd/MM/y')
    let finalDateResult: Date = this.getDateWithoutTime(new Date(event));

    // console.clear();

    if(itemSelectId == "DateValidTo")
    {
      let tempStartDate: Date = new Date(item.DateValidFrom);
      tempStartDate = this.getDateWithoutTime(tempStartDate);
      item.DateValidTo = finalDateResult;

     console.log("1. dateto : " + finalDateResult);
     console.log("1. datefrom : " + tempStartDate);

      item.NumberOfDays = this.getDifferenceInDays(tempStartDate, finalDateResult);
    }
    else
    {
      item.DateValidFrom = finalDateResult;
      item.MaxDate =  this.addDays(new Date(event), 14);
      let tempEndDate: Date = new Date(item.DateValidTo);
      tempEndDate = this.getDateWithoutTime(tempEndDate);

      console.log("2. dateto : " + tempEndDate);
      console.log("2. datefrom : " + finalDateResult);


      item.NumberOfDays = this.getDifferenceInDays(finalDateResult, tempEndDate);
    }

    this.validateNumberOfDays(item);
  }

  getPermtypeToUse(permit) : any
  {
    switch(this.ctrlData.data.permit_type.id)
    {
      case 15: //Amendment of Permit
      case 16: //Replacement of Vehicle
      case 17: //Correction of Permit
      case 32: //Duplicate Permits
          return permit.permit_type;
        break;
        default:
         return this.ctrlData.data.permit_type;
          break
    }
  }

  validateNumberOfDays(permit) : Boolean
  {
    let isDatesInvalid  = true;
    let permitType = this.getPermtypeToUse(permit);
    let validNumberOfDays = this.getValidNumberOfDays(permitType, permit);

    if(permit.NumberOfDays < 0)
    {
      this.notify.error("Valid To Date cannot be in the past.", 'Date Range Validation', { timeOut: 1000 });
    }
    else if(permit.NumberOfDays == 0)
    {
      this.notify.error("Number of days cannot be 0.", 'Date Range Validation', { timeOut: 1000 });
    }
    else
    if(permit.NumberOfDays > validNumberOfDays)
    {
      this.notify.error('Number of days cannot exceed '+ validNumberOfDays + ' days!', 'Date Range Validation', { timeOut: 1000 });
    }
    else{
      isDatesInvalid = false; //Validation Passed
    }
    this.isLoading = false;

    return !isDatesInvalid;
  }

  getDifferenceInDays(dateStart:Date, dateEnd:Date)
  {
    let timeInMilisec: number = dateEnd.getTime() - dateStart.getTime();
    let daysBetweenDates: number = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));

    return daysBetweenDates;
  }

  formatDate(dateTime: Date)
  {
    let year = dateTime.getFullYear();
    let month = dateTime.getMonth();
    let day = dateTime.getDay();
    let strFinalDate = day + "/" + month + "/" + year;

    return new Date(strFinalDate);
  }

   getDateWithoutTime(dateTime) {
    var date = new Date(dateTime.getTime());
    date.setHours(0, 0, 0, 0);
    return date;
}

addDays(date: Date, days: number): Date {
  date.setDate(date.getDate() +days);
  return date;
}
 //==================================================================

}
